var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9EA",
  d: "M2.181.626 2.9.396c.672-.214 1.391.133 1.68.812L5.15 2.56c.25.589.111 1.281-.342 1.712L3.545 5.471q.117 1.076.724 2.118c.383.672.898 1.26 1.513 1.73L7.3 8.812c.575-.191 1.202.03 1.554.547l.822 1.207c.41.603.336 1.433-.173 1.944l-.545.547a2.01 2.01 0 0 1-2.034.519q-2.54-.792-4.669-4.702Q.121 4.958.75 2.229C.925 1.463 1.469.853 2.18.626"
})));
export { SvgPhone as ReactComponent };